import { render } from "./AccueilView.vue?vue&type=template&id=cafa28aa&scoped=true"
import script from "./AccueilView.vue?vue&type=script&lang=js"
export * from "./AccueilView.vue?vue&type=script&lang=js"

import "./AccueilView.vue?vue&type=style&index=0&id=cafa28aa&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cafa28aa"]])

export default __exports__